import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const accessoryConfigRequest = createAction(
  types.ACCESSORY_CONFIG_REQUEST,
);
export const accessoryConfigSuccess = createAction(
  types.ACCESSORY_CONFIG_SUCCESS,
);
export const accessoryConfigFailure = createAction(
  types.ACCESSORY_CONFIG_FAILURE,
);

export const accessoryConfigUpdateRequest = createAction(
  types.ACCESSORY_CONFIG_UPDATE_REQUEST,
);
export const accessoryConfigUpdateSuccess = createAction(
  types.ACCESSORY_CONFIG_UPDATE_SUCCESS,
);
export const accessoryConfigUpdateFailure = createAction(
  types.ACCESSORY_CONFIG_UPDATE_FAILURE,
);

export const accessoryUpdateRequest = createAction(
  types.ACCESSORY_UPDATE_REQUEST,
);
export const accessoryUpdateSuccess = createAction(
  types.ACCESSORY_UPDATE_SUCCESS,
);
export const accessoryUpdateFailure = createAction(
  types.ACCESSORY_UPDATE_FAILURE,
);
export const insigniaEnabledMakesRequest = createAction(
  types.INSIGNIA_ENABLED_REQUEST,
);
export const insigniaEnabledMakesSuccess = createAction(
  types.INSIGNIA_ENABLED_SUCCESS,
);
export const insigniaEnabledMakesFailure = createAction(
  types.INSIGNIA_ENABLED_FAILURE,
);

export default {
  accessoryConfigRequest,
  accessoryConfigSuccess,
  accessoryConfigFailure,
  accessoryConfigUpdateRequest,
  accessoryConfigUpdateSuccess,
  accessoryConfigUpdateFailure,
  accessoryUpdateRequest,
  accessoryUpdateSuccess,
  accessoryUpdateFailure,
  insigniaEnabledMakesRequest,
  insigniaEnabledMakesSuccess,
  insigniaEnabledMakesFailure,
};
